import { Carousel } from 'antd';
import React from 'react';
// import { MdOutlineContentCopy } from 'react-icons/md';
// import { useSelector } from 'react-redux';
// import telegram from '../../../../assets/images/cib_telegram-plane.svg';
// import whatsapp from '../../../../assets/images/logos_whatsapp.svg';
// import { RootState } from '../../../../store/rootReducer';
// import emailIcon from '../../../../assets/images/mdi_email.svg';
// import messanger from '../../../../assets/images/messanger.svg';
// import next from '../../../../assets/images/next.png';
// import previous from '../../../../assets/images/previous.png';
// import Apis from '../../../../api';
import fundSign from '../../../../assets/images/referral/fund_sign.svg';
import payoutSign from '../../../../assets/images/referral/payout_sign.svg';
import referSign from '../../../../assets/images/referral/referral_refer_icon.svg';
// import Loader from '../../../common/Loader';
// import MessageActions from '../../../message/redux/actions';
// import ReferralsActions from '../redux/actions';
// import ReferralFirstBlock from './firstBlock';

type Props = {
    copyToClipboard?: (text: string) => void;
};

const data = [
    {
        icon: referSign,
        title: 'Refer',
        subText: `Submit your referral's details and we will handle the rest`,
    },
    { icon: fundSign, title: 'Sign-up & Fund', subText: 'Your friend joins the Helicap community and invests' },
    {
        icon: payoutSign,
        title: 'Payout',
        subText: `A successful investment triggers a referral payout for you!`,
    },
];

const ReferralView: React.FC<Props> = () => {
    // const dispatch = useDispatch();

    // const user = useSelector((state: RootState) => state.user.user);
    // const uuid = useSelector((state: RootState) => state.user?.uuid);

    // const referralUrl = `${window.location.origin}/referral/${user && user.referralCode}`;
    // const [referralCode, setReferralCode] = useState('');
    // const [isEligible, setEligible] = useState(false);
    // const [eligibleLoader, setEligibleLoader] = useState(false);

    // useLayoutEffect(() => {
    //     if (uuid) {
    //         setEligibleLoader(true);
    //         dispatch(ReferralsActions.getReferralDetail(uuid));
    //         Apis.getIsEligibleReferrar()
    //             .then((res) => {
    //                 if (res) {
    //                     setEligible(res.data);
    //                     setEligibleLoader(false);
    //                 }
    //             })
    //             .catch((err) => {
    //                 dispatch(MessageActions.showMessage({ error: true, text: String(err) }));
    //                 setEligible(false);
    //                 setEligibleLoader(false);
    //             })
    //             .finally(() => setEligibleLoader(false));
    //     }
    // }, [dispatch, uuid]);

    // const onEnterReferralCode = () => {
    //     if (referralCode && uuid) {
    //         Apis.addReferral(uuid, { code: referralCode })
    //             .then((res) => {
    //                 if (res) {
    //                     setEligible(false);
    //                     dispatch(MessageActions.showMessage({ error: false, text: 'Referral added successfully' }));
    //                 }
    //             })
    //             .catch((err) => {
    //                 dispatch(MessageActions.showMessage({ error: true, text: String(err) }));
    //             });
    //         setReferralCode('');
    //     }
    // };

    // const SlickArrowLeft = ({ currentSlide, slideCount, ...props }: any) => (
    //     <img {...props} className={'slick-next slick-arrow'} src={next} alt="next" />
    // );

    // const SlickArrowRight = ({ currentSlide, slideCount, ...props }: any) => (
    //     <img {...props} className={'slick-prev slick-arrow'} src={previous} alt="prev" />
    // );

    // const settings = {
    //     dots: false,
    //     infinite: true,
    //     speed: 500,
    //     slidesToShow: 1,
    //     slidesToScroll: 1,
    //     prevArrow: <SlickArrowRight />,
    //     nextArrow: <SlickArrowLeft />,
    // };
    // const socialMediaIcon = [
    //     {
    //         icon: whatsapp,
    //         name: 'whatsapp',
    //         link: `https://api.whatsapp.com/send?text=Helicap is an MAS-licensed private investment company that provides access to only the best-in-class private debt and equity opportunities in South East Asia. I am currently using it and would like to invite you to sign up (no investment required) to find out more: ${referralUrl}`,
    //     },
    //     {
    //         icon: messanger,
    //         name: 'fb-messanger',
    //         link: `fb-messenger://share?link=${referralUrl}`,
    //     },
    //     {
    //         icon: telegram,
    //         name: 'telegram',
    //         link: `tg://msg?text=Helicap is an MAS-licensed private investment company that provides access to only the best-in-class private debt and equity opportunities in South East Asia. I am currently using it and would like to invite you to sign up (no investment required) to find out more: ${referralUrl}`,
    //     },
    //     // {
    //     //     icon: emailIcon,
    //     //     name: 'email',
    //     //     link: `mailto:?subject=Alternative investing with Helicap&body=Hi,%0a%0a“Alternative investments managed in the Asia Pacific region may reach almost $5 trillion by 2025, as strong investor appetite in the fast-growing area drives the biggest increase in the world” - Bloomberg%0a%0aI’ve found that Helicap has an array of quality private investment opportunities right on their digital platform. Instead of gathering as many investments as they can on their platform, they are highly selective and work hard to find the best opportunities for their clients.%0a%0aI've started my investment with Helicap Pte Ltd and believe that you may also be interested to check out their offerings.
    //     // %0a%0aSign up here ${referralUrl} to check out their investments.%0a%0a[Helicap is an MAS-licensed private investment company.]`,
    //     // },
    // ];
    const values = {
        title: 'Share YOUR referral link',
        subText: 'Copy and send your referral link or share it on your social media.',
        howItWorks: 'How it works',
    };
    return (
        <>
            <div className="w-full">
                <div className="w-full">
                    {/* <div className="referral_third_block w-full p-4 md:py-8 md:px-20">
                        <p className="font-[WorkSans-Semibold] not-italic font-bold uppercase text-[#20222B] py-2 md:py-0 text-lg text-left">
                            {values.title}
                        </p>
                        <p className="font-[Lato] text-[#20222B] not-italic font-normal text-sm md:text-base md:pt-3 text-left">
                            {values.subText}
                        </p>
                        <div className="md:flex md:pt-6">
                            <div className="bg-[#E1EBF8] w-full h-auto flex-col md:flex-row md:h-12 my-4 md:my-0 py-2 md:py-0 flex items-center justify-between px-8 overflow-hidden">
                                <p className="text-[#20222B] text-base font-[Lato]">{referralUrl}</p>
                                <div className="flex justify-center py-2 md:py-0">
                                    <div className="mx-4 flex justify-center items-center">
                                        <MdOutlineContentCopy
                                            onClick={() => copyToClipboard(`${referralUrl}`)}
                                            className="text-2xl cursor-pointer text-[#142C53]"
                                        />
                                    </div>
                                    {socialMediaIcon.map((item, i) => (
                                        <div key={i + 9} className="mx-2 flex justify-center items-center">
                                            <a href={item.link} target={'_blank'} rel="noreferrer">
                                                <img src={item.icon} alt={item.name} className="h-6 w-6" />
                                            </a>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div> */}

                    {/* {!eligibleLoader && isEligible && (
                        <div>
                            <ReferralFirstBlock
                                setReferralCode={(value: string) => setReferralCode(value)}
                                referralCode={referralCode}
                                onEnterReferralCode={() => onEnterReferralCode()}
                            />
                        </div>
                    )}
                    {eligibleLoader && (
                        <div className="flex justify-center items-center m-4">
                            <Loader />
                        </div>
                    )} */}
                    <div className="referral_third_block w-full py-8 px-4 md:px-12">
                        <div className="hidden md:block">
                            {/* <p className="text-[#406DB6] font-[WorkSans-Semibold] not-italic text-base text-center pb-3">
                                REFERRAL PROCESS
                            </p> */}
                            <p className="text-[#13223E] font-[WorkSans-Semibold] not-italic text-[40px] pt-6 px-12">
                                {values.howItWorks}
                            </p>
                            <div className="flex justify-center">
                                {data.map((item, i) => (
                                    <div className="w-2/8 px-6" key={i}>
                                        <div className="w-full h-full py-4 px-6">
                                            <div className="text-[128px] text-[#E6F1FF] font-[WorkSans-Semibold] font-extrabold">
                                                0{i + 1}
                                            </div>
                                            <div className='border-s border-[#E6F1FF] pl-4'>
                                                <div className="text-[45px] text-[#13974B] font-[WorkSans-Semibold]">
                                                    {item.title}
                                                </div>
                                                <p className="text-lg font-normal text-[#20222B] w-4/5 font-[WorkSans]">
                                                    {item.subText}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className="block md:hidden">
                            {/* <p className="text-[#406DB6] font-[WorkSans-Semibold] font-bold not-italic text-sm text-center pb-3">
                                REFERRAL PROCESS
                            </p> */}
                            <p className="text-[#13223E] font-[WorkSans-Semibold] not-italic text-3xl pb-4">
                                {values.howItWorks}
                            </p>
                            <Carousel
                                effect="fade"
                                dots={true}
                                lazyLoad="progressive"
                                autoplay={true}
                                speed={1000}
                                className="referralCarousel"
                            >
                                {' '}
                                {/*{...settings} arrows>*/}
                                {data.map((item, i) => (
                                    <div key={i} className="w-full">
                                        <div className="w-full h-full py-4">
                                            <div className="text-[84px] text-[#E6F1FF] font-extrabold font-[WorkSans-Semibold]">0{i + 1}</div>
                                            <div className='border-s border-[#E6F1FF] pl-4'>
                                                <div className="text-[32px] text-[#13974B] font-[WorkSans-Semibold]">
                                                    {item.title}
                                                </div>
                                                <p className="text-sm font-normal text-[#20222B] w-4/5 font-[WorkSans]">{item.subText}</p>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </Carousel>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ReferralView;
